import { render, staticRenderFns } from "./SourceProductsMappings.vue?vue&type=template&id=163265e7&scoped=true"
import script from "./SourceProductsMappings.vue?vue&type=script&lang=js"
export * from "./SourceProductsMappings.vue?vue&type=script&lang=js"
import style0 from "./SourceProductsMappings.vue?vue&type=style&index=0&id=163265e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163265e7",
  null
  
)

export default component.exports